import { render, staticRenderFns } from "./OurBrandsPage.vue?vue&type=template&id=e5da9be8&scoped=true"
import script from "./OurBrandsPage.vue?vue&type=script&lang=js"
export * from "./OurBrandsPage.vue?vue&type=script&lang=js"
import style0 from "./OurBrandsPage.vue?vue&type=style&index=0&id=e5da9be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5da9be8",
  null
  
)

export default component.exports